import { Component, ContentChild, HostBinding, Input } from '@angular/core';
import { EmptyStateTextDirective, EmptyStateTitleDirective } from './empty-state.directive';

@Component({
    selector: 'app-empty-state',
    templateUrl: './empty-state.component.html',
    styleUrls: ['./empty-state.component.scss'],
    host: { class: 'empty-state' },
})
export class EmptyStateComponent
{
    @Input() icon = '';
    @Input() align: 'left' | 'center' | 'right' = 'center';

    @Input() searchTerm = '';
    @Input() subDirectory = '';

    @ContentChild(EmptyStateTitleDirective) title!: EmptyStateTitleDirective;
    @ContentChild(EmptyStateTextDirective) text!: EmptyStateTextDirective;

    readonly iconSrcDirectory = '/assets/images/v2/payhoa/empty-states/';

    @HostBinding('class.align-left') get alignLeft() {
        return this.align === 'left';
    }

    @HostBinding('class.align-right') get alignRight() {
        return this.align === 'right';
    }

    get iconSrc() {
        return this.iconSrcDirectory + (this.subDirectory ? (this.subDirectory + '/') : '') + this.icon + '-empty.svg';
    }
}
